export default __webpack_public_path__ + "static/media/zertiassist_iconos_form_24px.4f0191f5.svg";